export default __webpack_public_path__ + "static/media/PKGP.514b5031.png";